// React imports
import React from 'react';

// gatsby imports
import { PageProps, graphql } from 'gatsby';

// SEO
import SEO from 'components/seo';

// Theme and layout
import WithTheme from 'components/WithTheme';
import Layout from 'views/Layout';

// Page views
import Savings from 'views/Savings';

type DataProps = {
    site: {
        buildTime: string;
    };
};

const ApartadosPage: React.FC<PageProps<DataProps>> = ({ data, path, location }) => (
    <WithTheme>
        <Layout location={location}>
            <SEO title="Apartados" />

            <Savings />
        </Layout>
    </WithTheme>
);

export default ApartadosPage;

export const query = graphql`
    {
        site {
            buildTime(formatString: "YYYY-MM-DD hh:mm a z")
        }
    }
`;
